import { GlobalStyles as MuiGlobalStyles } from '@mui/material';
import { Theme } from '@mui/material/styles';

/**
 * Global styles for the application
 * These styles complement the Material-UI theme
 */
export const GlobalStyles = () => (
  <MuiGlobalStyles
    styles={(theme: Theme) => ({
      '*': {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
      },
      html: {
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        WebkitTextSizeAdjust: '100%',
        height: '100%',
        width: '100%',
        scrollBehavior: 'smooth',
      },
      // min-height (não height) para não limitar o bloco de contenção da navegação sticky
      body: {
        minHeight: '100%',
        width: '100%',
        overflowX: 'hidden',
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
      },
      '#root': {
        minHeight: '100%',
        width: '100%',
      },
      a: {
        textDecoration: 'none',
        color: 'inherit',
      },
      'a:hover': {
        textDecoration: 'none',
      },
      img: {
        maxWidth: '100%',
        height: 'auto',
        display: 'block',
      },
      'h1, h2, h3': {
        textWrap: 'balance',
      },
      p: {
        textWrap: 'pretty',
      },
      // Foco visível só para teclado; o mouse não exibe contorno
      'a:focus-visible, button:focus-visible, [role="button"]:focus-visible, [tabindex]:focus-visible, summary:focus-visible': {
        outline: `3px solid ${theme.palette.brand.text}`,
        outlineOffset: 2,
        borderRadius: 2,
      },
      'input:focus, textarea:focus, select:focus': {
        outline: 'none',
      },
      // Alvo de "Pular para o conteúdo": recebe foco por script, sem contorno
      'main[tabindex="-1"]:focus': {
        outline: 'none',
      },
      '.main': {
        minHeight: 'calc(100vh - 400px)',
      },
      '@media (prefers-reduced-motion: reduce)': {
        html: {
          scrollBehavior: 'auto',
        },
        '*, *::before, *::after': {
          animationDuration: '0.01ms !important',
          animationIterationCount: '1 !important',
          transitionDuration: '0.01ms !important',
        },
      },
    })}
  />
);
